import React, { type JSX } from 'react';
import { getCurrentUser } from '@features/auth';
import { Navigate } from 'react-router-dom';
import { publicRoutes, privateRoutes } from '@constants';
import { userType } from '@constants/userTypes';
import { getUserTypes } from '@features/auth/utils/getUserTypes.ts';

const AuthRedirect = (): JSX.Element => {
  const currentUser = getCurrentUser();

  if (currentUser == null) {
    return <Navigate to={publicRoutes.LOGIN} replace />;
  }

  const types = getUserTypes(currentUser);

  if (types.includes(userType.ADMIN) || types.includes(userType.SDR)) {
    return <Navigate to={privateRoutes.HOME} replace />;
  }

  if (types.includes(userType.AGENT)) {
    return <Navigate to={privateRoutes.AGENT} replace />;
  }

  return <Navigate to="/404" replace />;
};

export default AuthRedirect;
